import { createTheme, type MantineTheme, Modal } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineModal: PartialDeep<MantineTheme> = createTheme({
  components: {
    Modal: Modal.extend({
      styles: {
        title: {
          fontWeight: 600,
          fontSize: '1.2rem',
        },
        header: {
          borderBottom: '1px solid lightgrey',
          paddingBottom: '12px',
          paddingTop: '12px',
        },
        body: {
          paddingTop: 'var(--mantine-spacing-md)',
        },
      },
      defaultProps: {
        centered: true,
      },
    }),
  },
});
